export default __webpack_public_path__ + "static/media/pattern_sequence.bb33de96.png";